;(function () {
	'use strict';//Indicating browser should run only in java script mode

	angular
		.module('EMR.Home')
		.service('BlockedAppointmentsCommonService', BlockedAppointmentsCommonService)

	BlockedAppointmentsCommonService.$inject = ['CommonService','CommonPostService'];

	function BlockedAppointmentsCommonService(CommonService, CommonPostService) {
		///*******PURPOSE:THIS METHOD TO GET THE BLOCKED APPTS INFORMATION TO SHOW IN THE DAY VIEW TO SHOW IN SCHEDULER APPTS VIEW BLOCK START ##############################
		///*******CREATED BY: PAVAN KUMAR KANDULA
		///*******CREATED DATE: 3RD JAN 2018
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
		var blockedAppointmentsGetPhysicianRelatedDayViewBlockedApptsList_Latest = function (postData) {
			//postData.practicemodel = EMRPracticeModel;
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonPostService.httpPostData('POST', CommonPostService.EHR_ApptsFormat1_DayView_API() + "GetDayViewBlockedAppointmentsList", postData).then(
				function (result) {
					return result;
				});
		};
		///*******PURPOSE:THIS METHOD TO GET THE BLOCKED APPTS INFORMATION TO SHOW IN THE DAY VIEW TO SHOW IN SCHEDULER APPTS VIEW BLOCK END ##############################

		///*******PURPOSE:THIS METHOD TO GET THE BLOCKED APPTS INFORMATION TO SHOW IN THE APPTS VIEW TO SHOW IN SCHEDULER APPTS VIEW BLOCK START ##############################
		///*******CREATED BY: SRINIVAS M
		///*******CREATED DATE: 28TH DEC 2018
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
		var blockedAppointmentsGetApptSchedulerBlockedApptsInfoList_Latest = function (postData) {
			postData.practicemodel = EMRPracticeModel;
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			postData.UserType = EMRPracticeModel.UserType;
			return CommonPostService.httpPostData('POST', CommonPostService.EHR_ApptsFormat1_GridView_API() + "GetApptSchedulerBlockedApptsInfoList", postData).then(
				function (result) {
					return result;
				});
		};
		///*******PURPOSE:THIS METHOD TO GET THE BLOCKED APPTS INFORMATION TO SHOW IN THE APPTS VIEW TO SHOW IN SCHEDULER APPTS VIEW BLOCK END ##############################

		///*******PURPOSE:THIS METHOD TO GET THE BLOCKED APPTS INFORMATION TO SHOW IN THE APPTS VIEW TO SHOW IN SCHEDULER DAY2 VIEW BLOCK START ##############################
		///*******CREATED BY: PAVAN KUMAR KANDULA
		///*******CREATED DATE: 2 FEB 2019
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
		var blockedAppointmentsGetDay2ViewBlockedAppointmentInformationList_Latest = function (postData) {
			postData.UserType = EMRPracticeModel.UserType;
            //postData.practicemodel = EMRPracticeModel;
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonPostService.httpPostData('POST', CommonPostService.EHR_ApptsFormat1_Day2View_API() + "GetDay2ViewBlockedAppointmentsList", postData).then(
				function (result) {
					return result;
				});
		};
		///*******PURPOSE:THIS METHOD TO GET THE BLOCKED APPTS INFORMATION TO SHOW IN THE APPTS VIEW TO SHOW IN SCHEDULER APPTS VIEW BLOCK END ##############################


		//############   THIS IS USED TO GET THE VALIDATION FOR THE SELECTED DATE EPISODE CREATED OR NOT  BLOCK END   ################
		//#############   CHECK THE IF SELECTED PATIENT AND PROVIDER MAXIMUM ALLOWED APPTS REACHED OR NOT BLOCK START   ##################
		//*******PURPOSE            : THIS METHOD IS USED TO CHECK THE IF SELECTED PATIENT AND PROVIDER MAXIMUM ALLOWED APPTS REACHED OR NOT 
		//*******CREATED BY         : NAGA TEJA N
		//*******CREATED DATE       : JUNE 07 2019
		//*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
		var blockedAppointmentsGetBlockedApptsRelatedInfoRelatedToValidations = function (postData) {
			postData.practicemodel = EMRPracticeModel;
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EMRAppointmentScheduler() + "GetBlockedApptsRelatedInfoRelatedToValidations", postData).then(
				function (result) {
					return result;
				});
		}
		//############CHECK THE IF SELECTED PATIENT AND PROVIDER MAXIMUM ALLOWED APPTS REACHED OR NOT BLOCK END   ################


		return {
			blockedAppointmentsGetPhysicianRelatedDayViewBlockedApptsList_Latest: blockedAppointmentsGetPhysicianRelatedDayViewBlockedApptsList_Latest,

			blockedAppointmentsGetApptSchedulerBlockedApptsInfoList_Latest: blockedAppointmentsGetApptSchedulerBlockedApptsInfoList_Latest,

			blockedAppointmentsGetDay2ViewBlockedAppointmentInformationList_Latest: blockedAppointmentsGetDay2ViewBlockedAppointmentInformationList_Latest,

			blockedAppointmentsGetBlockedApptsRelatedInfoRelatedToValidations: blockedAppointmentsGetBlockedApptsRelatedInfoRelatedToValidations,
		};
	}
})();